import React, { createContext, ReactNode } from 'react';
import { usePortalBranding, PortalBranding } from 'vopay';

export const BrandingContext = createContext<PortalBranding>({
  primaryColor: '',
  secondaryColor: '',
  logo: '',
  smallLogo: '',
  appTitle: '',
  setBrandingValues: () => {},
});

type BrandingProviderProps = {
  children: ReactNode | ReactNode;
};

export const BrandingContextProvider = ({ children }: BrandingProviderProps): React.JSX.Element => {
  const portalBranding = usePortalBranding('Partner Dashboard');

  return <BrandingContext.Provider value={portalBranding}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => React.useContext(BrandingContext);
